import { GameSceneType } from "features/courses/program/game/stages/types";
import { Display } from "./Display";
import { Runtime } from "./Runtime";
import ToolboxInfo from "./ToolboxInfo";

const GameScene: GameSceneType = {
  Display: Display,
  Runtime: Runtime,
  ToolboxInfo: ToolboxInfo,
};

export default GameScene;
